import React, { useContext, useState, useEffect } from 'react';
import {
  Modal,
  Form,
  Input,
  DatePicker,
  Card,
  Avatar,
  List,
  Collapse,
  Typography,
  Button,
  Popconfirm,
  Row,
  Col,
  message,
} from 'antd';
import {
  CloseOutlined,
  UsergroupAddOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { StoreContext } from '../store/index';
import {
  removePlayerFromfriendsList,
  addFriendsListToPlayer,
  addPlayerToFriendsList,
  removeFriendsListFromUser,
} from '../profile/api';
import { getDateFromTimestamp, copyText } from '../utils';
import PlayerProfileDrawer from '../profile/playerProfileDrawer';
import PlayersList from './PlayersList';
import ListUsersModal from './ListUsersModal';

const { Paragraph, Title } = Typography;

function TeamList({ header, dataSource, handleShareWithFriendsList = null }) {
  const store = useContext(StoreContext);
  const { formatMessage } = useIntl();
  const {
    user: [user, setUser, setUpdateUser],
    isUserLoading: [isUserLoading, setIsUserLoading],
    allRequests: [allRequests],
  } = store;

  const { Panel } = Collapse;

  const [showPlayerProfile, setShowPlayerProfile] = useState(false);
  const [showListUsersModal, setShowListUsersModal] = useState(false);
  const [friendsListInputName, setFriendsListInputName] = useState(false);
  const [selectedFriendsListName, setSelectedfriendsListName] = useState('');
  const [playerProfileId, setPlayerProfileId] = useState('false');
  const [open, setOpen] = useState();
  const [loading, setLoading] = useState(false);
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [filterValue, setFilterValue] = useState('');

  const handleRemovePlayerFromTeam = player => {
    removePlayerFromfriendsList(
      user.uid,
      player.friendsListName,
      user.friendsList,
      player.id,
      setLoading,
    ).then(() => setUpdateUser(true));
  };

  const handleFilter = value => {
    setFilteredDataSource(
      value !== ''
        ? dataSource.filter(data =>
            data.friendsListName.toUpperCase().includes(value.toUpperCase()),
          )
        : dataSource,
    );
  };

  const isfriendsListNameUsed = name => {
    let isUsed = false;
    user.friendsList.forEach(t => {
      if (t.friendsListName === name) {
        isUsed = true;
      }
    });
    return isUsed;
  };
  const handleAddFriendsListToPlayer = async () => {
    if (isfriendsListNameUsed(friendsListInputName)) {
      return message.error('Ya existe un equipo con ese nombre');
    }
    await addFriendsListToPlayer(
      user.uid,
      friendsListInputName,
      setLoading,
      user.friendsList,
    );
    setUpdateUser(true);
    setFriendsListInputName('');
    return true;
  };
  const handleRemoveTeamFromUser = friendsListName => {
    removeFriendsListFromUser(
      user.uid,
      friendsListName,
      setLoading,
      user.friendsList,
    ).then(() => setUpdateUser(true));

    setFriendsListInputName('');
  };

  const handleAddPlayerToTeam = player => {
    addPlayerToFriendsList(
      user.uid,
      selectedFriendsListName,
      user.friendsList,
      { nickname: player.nickname, photoURL: player.photoURL, id: player.id },
      setLoading,
    ).then(() => setUpdateUser(true));
  };

  useEffect(() => {
    handleFilter(filterValue);
  }, [filterValue, dataSource]);

  return (
    <>
      <Collapse
        key="Teams"
        className="width100"
        style={{ marginTop: '2px' }}
        activeKey={open}
        onChange={() => setOpen(open === 'teamsPanel' ? '' : 'teamsPanel')}
        items={[
          {
            key: 'teamsPanel',
            label: header,
            children: (
              <div
                style={{
                  overflow: 'auto',
                  maxHeight: '300px',
                  scrollbarWidth: 'thin',
                }}>
                <Input
                  style={{ marginBottom: '6px' }}
                  placeholder="Filtrar"
                  value={filterValue}
                  onChange={e => setFilterValue(e.target.value)}
                />
                <List
                  size="small"
                  itemLayout="vertical"
                  loading={loading || isUserLoading}
                  open
                  dataSource={filteredDataSource}
                  renderItem={friendsList => (
                    <List.Item
                      style={{ padding: '0px', marginTop: '8px' }}
                      key={friendsList.friendsListName}>
                      <PlayersList
                        startOpen={false}
                        header={
                          <Row justify="space-between">
                            <Col xs={10}>{friendsList.friendsListName}</Col>
                            {handleShareWithFriendsList ? (
                              <Col xs={14}>
                                <Row justify="end">
                                  <Col>
                                    <Button
                                      style={{ marginRight: '8px' }}
                                      key={friendsList.id}
                                      type="primary"
                                      loading={loading}
                                      icon={<UserAddOutlined />}
                                      onClick={e => {
                                        e.preventDefault();
                                        handleShareWithFriendsList(
                                          friendsList.friendsListName,
                                        );
                                      }}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            ) : (
                              <Col xs={14}>
                                <Row justify="end">
                                  <Col>
                                    <Button
                                      style={{ marginRight: '8px' }}
                                      key={friendsList.id}
                                      type="primary"
                                      loading={loading}
                                      icon={<UserAddOutlined />}
                                      onClick={() => {
                                        setSelectedfriendsListName(
                                          friendsList.friendsListName,
                                        );
                                        setShowListUsersModal(true);
                                      }}
                                    />
                                  </Col>
                                  <Col>
                                    <Button
                                      style={{ marginRight: '8px' }}
                                      key={friendsList.id}
                                      loading={loading}
                                      danger
                                      icon={<CloseOutlined />}
                                      onClick={() =>
                                        handleRemoveTeamFromUser(
                                          friendsList.friendsListName,
                                        )
                                      }
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            )}
                          </Row>
                        }
                        dataSource={friendsList.players.map(p => ({
                          ...p,
                          friendsListName: friendsList.friendsListName,
                        }))}
                        handleRemovePlayerFromTeam={
                          handleShareWithFriendsList
                            ? null
                            : handleRemovePlayerFromTeam
                        }
                      />
                    </List.Item>
                  )}
                />
                <Popconfirm
                  title={formatMessage({
                    id: 'profile.add.team',
                  })}
                  description={
                    <Input
                      placeholder="Nombre del equipo"
                      value={friendsListInputName}
                      onChange={e => setFriendsListInputName(e.target.value)}
                    />
                  }
                  onOpenChange={() => setFriendsListInputName('')}
                  onConfirm={handleAddFriendsListToPlayer}
                  onCancel={() => setFriendsListInputName('')}
                  okText={formatMessage({ id: 'common.yes' })}
                  cancelText={formatMessage({ id: 'common.no' })}>
                  <Button
                    style={{ marginTop: '8px' }}
                    className="width100"
                    type="primary"
                    loading={loading}
                    icon={<UserAddOutlined />}>
                    {formatMessage({ id: 'profile.add.team' })}
                  </Button>
                </Popconfirm>
              </div>
            ),
          },
        ]}
      />
      {showPlayerProfile && playerProfileId && (
        <PlayerProfileDrawer
          playerId={playerProfileId}
          visible={showPlayerProfile}
          onClose={() => setShowPlayerProfile(false)}
        />
      )}
      {showListUsersModal && (
        <ListUsersModal
          title={`${formatMessage({
            id: 'profile.add.friend.to.list',
          })} ${selectedFriendsListName}`}
          visible={showListUsersModal}
          onClose={() => setShowListUsersModal(false)}
          usersToFilter={
            user.friendsList.find(
              t => t.friendsListName === selectedFriendsListName,
            )?.players || []
          }
          handleAddPlayerToTeam={handleAddPlayerToTeam}
          players={user.friends}
        />
      )}
    </>
  );
}

export default TeamList;
